import React, {useState, useEffect} from "react";
import SubReference from "../SubReference/SubReference";
// import './Reference.scss';

const Reference = (props) =>{

    const [toggle, setToggle] = useState(false);
    const [expand, setExpand] = useState (false);

    function handleClick() {
        setToggle(!toggle)
        setExpand(!expand)
        console.log(toggle)
    }
    console.log(props.data)
    const subReferences = props.subReferences.map((subReference, i) => {
            return <SubReference top={subReference.header} />

    }) 

    return(
        <div className={`Refrence`} onClick={handleClick}>
            <div className={`reference-header`}>
                <div className={`reference-title`}>
                    <h3>{props.header}</h3>
                </div>
                <div className={`toggle-container`}>
                    <div className={`toggle-button`}>{expand === false ? "+" : "-"}</div>
                </div>
            </div>
            <div className={`reference-body`}>
                {expand && subReferences}
            </div>
        </div>
    )
}

export default Reference